import { FunctionComponent } from "react";
import { ArrowBackIcon } from "../../icon";
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';

interface IProps {
    HeaderText: string;
    PreviousPage: () => void;
}

const SubPageHeaderComponent: FunctionComponent<IProps> = (props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    return <div className="box-shadow-primary-header-shadow d-flex w-fill p-2">
        {
            IsMobileDevice &&

            <span className="mr-1 my-auto" style={{ zIndex: 100 }}>

                <ArrowBackIcon onClick={props.PreviousPage} style={{ marginTop: "0.25rem" }} />
            </span>

        }
        <span className={`my-auto h1 ml-1`}>{props.HeaderText}</span>
    </div>;
}


export default SubPageHeaderComponent;
